document.documentElement.classList.remove('no-js');

/* Scroll reveal: fades/rises major section blocks into view once.

   Everything starts visible. This script hides an element only if it is
   still well below the fold at the moment the script runs, and the observer
   then reveals it on approach. Nothing the visitor can already see is ever
   hidden waiting for a callback, and a script that never runs leaves the
   page fully readable rather than blank — which matters here because the
   page ground is near-black, so an unrevealed block reads as a hole.

   Two failure modes in the previous version are closed by this:
   the stylesheet used to hide [data-reveal] up front and rely on this file
   to undo it, so a slow or blocked theme.js showed black rectangles; and a
   0.15 intersection threshold is unsatisfiable for anything taller than
   ~6.7 viewports once the negative bottom margin is applied, which stranded
   long sections until the visitor happened to scroll them into range. */
(function () {
  var nodes = document.querySelectorAll('[data-reveal]');
  if (!nodes.length) return;

  // Merchant switched the motion off, the visitor asked for less motion, or
  // the browser has no observer: in every case leave the page as it is.
  if (document.body && document.body.classList.contains('motion-reveal-disabled')) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  // A generous band. Anything nearer than this is left alone, so a fast
  // scroll during load cannot outrun the arming pass and expose a gap.
  var band = window.innerHeight * 1.5;
  var pending = [];

  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].getBoundingClientRect().top < band) continue;
    nodes[i].classList.add('reveal-armed');
    pending.push(nodes[i]);
  }
  if (!pending.length) return;

  // threshold 0: any pixel crossing the inset edge is enough, so element
  // height can never prevent a reveal.
  var revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        // isIntersecting covers the normal approach from below. The second
        // test catches an element the visitor blew straight past between two
        // frames: a fast wheel or an anchor jump can leave the observer
        // reporting a single non-intersecting entry once the element is
        // already above the viewport, and without this it would stay armed
        // and read as a blank block on the way back up.
        if (!entry.isIntersecting && entry.boundingClientRect.top >= 0) return;
        entry.target.classList.add('is-revealed');
        revealObserver.unobserve(entry.target);
      });
    },
    { threshold: 0, rootMargin: '0px 0px -8% 0px' }
  );

  pending.forEach(function (el) { revealObserver.observe(el); });
})();

/* Mobile nav drawer */
document.addEventListener('click', function (event) {
  var link = event.target.closest('.mobile-nav a');
  var closeButton = event.target.closest('[data-mobile-nav-close]');
  if (!link && !closeButton) return;
  var details = (link || closeButton).closest('details.mobile-nav-toggle');
  if (details) details.removeAttribute('open');
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  var open = document.querySelector('details.mobile-nav-toggle[open]');
  if (open) {
    open.removeAttribute('open');
    var summary = open.querySelector('summary');
    if (summary) summary.focus();
  }
});

/* Quantity steppers (cart page, cart drawer, product page) */
document.addEventListener('click', function (event) {
  var decrease = event.target.closest('[data-quantity-decrease]');
  var increase = event.target.closest('[data-quantity-increase]');
  if (!decrease && !increase) return;
  var wrapper = (decrease || increase).closest('.quantity-input');
  var input = wrapper.querySelector('.quantity-input__field');
  var min = parseInt(input.min || '0', 10);
  var max = input.max ? parseInt(input.max, 10) : Infinity;
  var value = parseInt(input.value || '1', 10);
  if (decrease) value = Math.max(min, value - 1);
  if (increase) value = Math.min(max, value + 1);
  input.value = value;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

/* Size guide modal */
var sizeGuideLastFocused = null;
document.addEventListener('click', function (event) {
  if (event.target.closest('[data-size-guide-open]')) {
    var modal = document.querySelector('[data-size-guide-modal]');
    if (modal) {
      sizeGuideLastFocused = document.activeElement;
      modal.hidden = false;
      var closeButton = modal.querySelector('[data-size-guide-close]');
      if (closeButton) closeButton.focus();
    }
  }
  if (event.target.closest('[data-size-guide-close]')) {
    var modalToClose = document.querySelector('[data-size-guide-modal]');
    if (modalToClose) {
      modalToClose.hidden = true;
      if (sizeGuideLastFocused && typeof sizeGuideLastFocused.focus === 'function') sizeGuideLastFocused.focus();
    }
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  var openModal = document.querySelector('[data-size-guide-modal]:not([hidden])');
  if (openModal) {
    openModal.hidden = true;
    if (sizeGuideLastFocused && typeof sizeGuideLastFocused.focus === 'function') sizeGuideLastFocused.focus();
  }
});

/* Customer login: toggle password recovery form */
document.addEventListener('click', function (event) {
  if (event.target.closest('[data-toggle-recover]')) {
    var recover = document.querySelector('[data-recover-form]');
    if (recover) recover.hidden = !recover.hidden;
  }
});

/* Customer addresses: toggle edit form, confirm deletion */
document.addEventListener('click', function (event) {
  var toggle = event.target.closest('[data-address-edit-toggle]');
  if (toggle) {
    var id = toggle.getAttribute('data-address-edit-toggle');
    var panel = document.querySelector('[data-address-edit-form="' + id + '"]');
    if (panel) panel.hidden = !panel.hidden;
  }
});

document.addEventListener('submit', function (event) {
  var submitter = event.submitter;
  if (submitter && submitter.hasAttribute('data-confirm')) {
    if (!window.confirm(submitter.getAttribute('data-confirm'))) {
      event.preventDefault();
    }
  }
});

/* Product card quick add */
document.addEventListener('click', function (event) {
  var toggle = event.target.closest('[data-quick-add-toggle]');
  if (!toggle) return;
  var card = toggle.closest('.product-card');
  var panel = card ? card.querySelector('[data-quick-add]') : null;
  if (!panel) return;
  var isHidden = panel.hasAttribute('hidden');
  if (isHidden) {
    panel.removeAttribute('hidden');
    toggle.setAttribute('aria-expanded', 'true');
  } else {
    panel.setAttribute('hidden', '');
    toggle.setAttribute('aria-expanded', 'false');
  }
});

document.addEventListener('change', function (event) {
  var input = event.target.closest('.product-card__quick-add-input');
  if (!input) return;
  var form = input.closest('form');
  var variantsScript = form.querySelector('[data-quick-add-variants]');
  if (!variantsScript) return;
  var variants = JSON.parse(variantsScript.textContent);
  var selected = Array.prototype.map.call(
    form.querySelectorAll('.product-card__quick-add-input:checked'),
    function (el) { return el.value; }
  );
  var matched = variants.find(function (variant) {
    return variant.options.every(function (opt, index) { return opt === selected[index]; });
  });
  var hiddenInput = form.querySelector('[data-quick-add-variant-id]');
  var submitButton = form.querySelector('.product-card__quick-add-submit');
  if (matched) {
    hiddenInput.value = matched.id;
    submitButton.disabled = !matched.available;
  } else {
    hiddenInput.value = '';
    submitButton.disabled = true;
  }
});

/* Header overlay.
   When the page opens with a full-bleed visual (hero, statement, collection
   banner), the header floats transparently over it and resolves to a solid
   bar on scroll. Detected from the DOM rather than hardcoded per template,
   so it works for any page that opens that way. Degrades to the normal
   solid header if JS never runs. */
(function () {
  var header = document.querySelector('.site-header');
  var main = document.getElementById('MainContent');
  if (!header || !main) return;

  var opener = main.firstElementChild;
  while (opener && !opener.getBoundingClientRect().height) opener = opener.nextElementSibling;

  // Shopify wraps every section in <div id="shopify-section-…" class="shopify-section">,
  // so the wrapper's className is always just "shopify-section" — the section's
  // own classes live one level down. Testing the wrapper meant this never
  // matched and the overlay header silently never engaged. Test the section
  // root instead, with a descendant lookup as a fallback.
  var openerRoot = opener && opener.firstElementChild;
  var FULL_BLEED = /(^|\s)(hero|statement|collection-banner)($|\s)/;
  var fullBleed = !!(
    (openerRoot && FULL_BLEED.test(openerRoot.className || '')) ||
    (opener && opener.querySelector('.hero, .statement, .collection-banner'))
  );
  if (!fullBleed) return;

  header.classList.add('site-header--overlay');

  // Pull the opening visual up under the (still in-flow) header, so the
  // header floats over the image without displacing the announcement bar.
  function syncOverlayOffset() {
    opener.style.marginTop = '';
    var h = header.getBoundingClientRect().height;
    opener.style.marginTop = (-h) + 'px';
  }
  syncOverlayOffset();
  window.addEventListener('resize', syncOverlayOffset);
  window.addEventListener('load', syncOverlayOffset);

  var solid = false;
  function syncHeader() {
    var past = window.scrollY > 40;
    if (past !== solid) {
      solid = past;
      header.classList.toggle('site-header--solid', past);
    }
  }
  syncHeader();
  window.addEventListener('scroll', syncHeader, { passive: true });
})();

/* Hero parallax: the image drifts slightly slower than the page. Small
   translate only — no scroll hijacking, and skipped entirely for reduced
   motion or when the browser can't do rAF cheaply. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var media = document.querySelector('.hero .hero__media-motion');
  if (!media) return;
  var hero = media.closest('.hero');
  var ticking = false;
  function update() {
    ticking = false;
    var rect = hero.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > window.innerHeight) return;
    var shift = Math.max(-60, Math.min(60, rect.top * -0.08));
    media.style.transform = 'translate3d(0,' + shift.toFixed(2) + 'px,0)';
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }, { passive: true });
  update();
})();

/* Gallery depth: each slide's image drifts a few pixels against its frame as
   the gallery scrolls past — the same idea as the hero parallax, at a
   smaller amplitude. Desktop only (the mobile gallery is a horizontal swipe
   carousel), rAF-throttled, and skipped under reduced motion. The scale in
   CSS covers the travel so no edge is exposed. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(min-width: 900px)').matches) return;
  var slides = document.querySelectorAll('.product-gallery__slide');
  if (!slides.length) return;
  var MAX = 14;
  var ticking = false;
  function update() {
    ticking = false;
    var vh = window.innerHeight;
    Array.prototype.forEach.call(slides, function (slide) {
      var rect = slide.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > vh) return;
      // -1 above the viewport centre, +1 below it.
      var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
      var drift = Math.max(-MAX, Math.min(MAX, progress * MAX));
      slide.style.setProperty('--gallery-drift', drift.toFixed(2) + 'px');
    });
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
})();

/* Rail arrows are only meaningful when the track actually overflows.
   A curated rail may legitimately hold fewer products than fill the
   viewport (a new store, a small collection), so hide the controls
   rather than showing dead buttons. Re-checked on resize. */
function syncRailArrows() {
  document.querySelectorAll('[data-product-rail]').forEach(function (rail) {
    var track = rail.querySelector('[data-product-rail-track]');
    if (!track) return;
    var scrollable = track.scrollWidth - track.clientWidth > 2;
    rail.querySelectorAll('[data-product-rail-prev], [data-product-rail-next]').forEach(function (btn) {
      btn.hidden = !scrollable;
    });
  });
}
window.addEventListener('load', syncRailArrows);
window.addEventListener('resize', syncRailArrows);
document.addEventListener('DOMContentLoaded', syncRailArrows);

/* Product rail arrow controls */
document.addEventListener('click', function (event) {
  var prevButton = event.target.closest('[data-product-rail-prev]');
  var nextButton = event.target.closest('[data-product-rail-next]');
  if (!prevButton && !nextButton) return;
  var rail = (prevButton || nextButton).closest('[data-product-rail]');
  var track = rail ? rail.querySelector('[data-product-rail-track]') : null;
  if (!track) return;
  var item = track.querySelector('.product-rail__item');
  var amount = item ? item.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
  track.scrollBy({ left: prevButton ? -amount : amount, behavior: 'smooth' });
});

/* Price range slider.
   Drives Shopify's native filter.v.price.gte / .lte parameters — it does not
   filter anything itself. Handles work in store-currency units (what those
   parameters expect); the money formatter takes cents, so values are
   multiplied by 100 only for display. */
(function () {
  // Standard Shopify money formatter: takes cents + the shop's money_format.
  function formatMoney(cents, format) {
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function thousands(number, precision, thousandsSep, decimalSep) {
      if (isNaN(number) || number === null) return '0';
      var fixed = (number / 100.0).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (thousandsSep || ','));
      var frac = parts[1] ? (decimalSep || '.') + parts[1] : '';
      return whole + frac;
    }

    var value;
    switch ((formatString.match(placeholderRegex) || [])[1]) {
      case 'amount_no_decimals': value = thousands(cents, 0); break;
      case 'amount_with_comma_separator': value = thousands(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = thousands(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = thousands(cents, 2, "'"); break;
      default: value = thousands(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  /* "Rs. 1,799.00" -> "Rs. 1,799". Handles both decimal conventions and
     leaves a non-zero fraction ("Rs. 1,799.50") untouched. */
  function dropZeroDecimals(formatted) {
    return formatted.replace(/([.,])00(?!\d)/, '');
  }

  document.querySelectorAll('[data-price-slider]').forEach(function (slider) {
    var minInput = slider.querySelector('[data-price-handle="min"]');
    var maxInput = slider.querySelector('[data-price-handle="max"]');
    var fill = slider.querySelector('[data-price-fill]');
    var minDisplay = slider.querySelector('[data-price-display="min"]');
    var maxDisplay = slider.querySelector('[data-price-display="max"]');
    var minParam = slider.querySelector('[data-price-param="min"]');
    var maxParam = slider.querySelector('[data-price-param="max"]');
    if (!minInput || !maxInput) return;

    var bMin = parseFloat(slider.getAttribute('data-min')) || 0;
    var bMax = parseFloat(slider.getAttribute('data-max')) || 0;
    var moneyFormat = slider.getAttribute('data-money-format');
    var span = bMax - bMin;

    function render() {
      var lo = parseFloat(minInput.value);
      var hi = parseFloat(maxInput.value);

      // Keep the handles from crossing: push whichever one isn't being moved.
      if (lo > hi) {
        if (document.activeElement === minInput) { hi = lo; maxInput.value = hi; }
        else { lo = hi; minInput.value = lo; }
      }

      if (span > 0 && fill) {
        fill.style.left = ((lo - bMin) / span) * 100 + '%';
        fill.style.width = ((hi - lo) / span) * 100 + '%';
      }
      /* Match snippets/price.liquid, which uses money_without_trailing_zeros:
         these are whole-rupee filter bounds, so ".00" is noise. Only the
         zero fraction is dropped — a real fraction is left alone. */
      if (minDisplay) minDisplay.textContent = dropZeroDecimals(formatMoney(lo * 100, moneyFormat));
      if (maxDisplay) maxDisplay.textContent = dropZeroDecimals(formatMoney(hi * 100, moneyFormat));

      // Leave a parameter empty when its handle sits at the bound, so an
      // untouched slider doesn't add a redundant filter to the URL.
      if (minParam) minParam.value = lo > bMin ? lo : '';
      if (maxParam) maxParam.value = hi < bMax ? hi : '';
    }

    minInput.addEventListener('input', render);
    maxInput.addEventListener('input', render);
    render();
  });
})();

/* Collection filters: force the sidebar open at desktop widths.
   Browsers intentionally ignore CSS display overrides on closed
   <details> content, so this has to be done by setting the
   attribute rather than styling around it. */
function syncFiltersOpenState() {
  if (!window.matchMedia('(min-width: 900px)').matches) return;
  document.querySelectorAll('.filters-toggle').forEach(function (el) {
    el.setAttribute('open', '');
  });
}
syncFiltersOpenState();
window.addEventListener('resize', syncFiltersOpenState);

/* ---------------------------------------------------------------------------
   QUICK-ADD: option availability + colour-driven card image

   Every option value is already rendered by product-card.liquid, so nothing
   here reveals options — it only marks the ones that cannot be bought and
   swaps the card image when a colourway is chosen, using the variant data
   Shopify already ships in the panel. No product-specific colours anywhere.
   --------------------------------------------------------------------------- */
(function () {
  var COLOUR = /colou?r/i;

  function variantsOf(form) {
    var el = form.querySelector('[data-quick-add-variants]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* A value is buyable if ANY variant carrying it is available. */
  function syncAvailability(form) {
    var variants = variantsOf(form);
    if (!variants) return;
    var groups = form.querySelectorAll('.product-card__quick-add-option');
    Array.prototype.forEach.call(groups, function (group) {
      var index = parseInt(group.getAttribute('data-option-index'), 10);
      if (isNaN(index)) return;
      var inputs = group.querySelectorAll('.product-card__quick-add-input');
      Array.prototype.forEach.call(inputs, function (input) {
        var buyable = variants.some(function (v) {
          return v.options[index] === input.value && v.available;
        });
        input.disabled = !buyable;
        var label = input.closest('.product-card__quick-add-label');
        if (label) label.classList.toggle('is-unavailable', !buyable);
      });
    });
  }

  /* Swap the card image to the chosen colourway. Uses the variant's own
     featured image, so it is always the right photograph for that colour. */
  function syncImage(form) {
    var variants = variantsOf(form);
    if (!variants) return;
    var group = null;
    var groups = form.querySelectorAll('.product-card__quick-add-option');
    Array.prototype.forEach.call(groups, function (g) {
      if (!group && COLOUR.test(g.getAttribute('data-option-name') || '')) group = g;
    });
    if (!group) return;

    var checked = group.querySelector('.product-card__quick-add-input:checked');
    if (!checked) return;
    var index = parseInt(group.getAttribute('data-option-index'), 10);
    if (isNaN(index)) return;

    var match = null;
    variants.some(function (v) {
      if (v.options[index] === checked.value && v.featured_image && v.featured_image.src) {
        match = v; return true;
      }
      return false;
    });
    if (!match) return;

    var card = form.closest('.product-card');
    var img = card && card.querySelector('.product-card__image--primary');
    if (!img) return;
    var src = match.featured_image.src;
    if (img.getAttribute('src') === src) return;
    /* srcset would otherwise keep winning over the new src. */
    img.removeAttribute('srcset');
    img.setAttribute('src', src);
    if (match.featured_image.alt) img.setAttribute('alt', match.featured_image.alt);
  }

  document.addEventListener('change', function (event) {
    var input = event.target.closest('.product-card__quick-add-input');
    if (!input) return;
    var form = input.closest('form');
    if (!form) return;
    syncAvailability(form);
    syncImage(form);
  });

  /* Availability is computed when the panel is first opened, so a card that is
     never opened costs nothing. */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-quick-add-toggle]');
    if (!toggle) return;
    var card = toggle.closest('.product-card');
    var form = card && card.querySelector('[data-quick-add] form');
    if (form) syncAvailability(form);
  });
})();
